var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27515 7.77519C5.45093 7.59963 5.68921 7.50102 5.93765 7.50102C6.18609 7.50102 6.42437 7.59963 6.60015 7.77519L10.0002 11.1752L13.4002 7.77519C13.486 7.68308 13.5895 7.60921 13.7045 7.55797C13.8195 7.50673 13.9436 7.47917 14.0695 7.47695C14.1954 7.47473 14.3204 7.49789 14.4371 7.54504C14.5539 7.59219 14.6599 7.66237 14.7489 7.75139C14.838 7.84042 14.9082 7.94646 14.9553 8.06319C15.0025 8.17993 15.0256 8.30497 15.0234 8.43085C15.0212 8.55672 14.9936 8.68087 14.9424 8.79586C14.8911 8.91086 14.8173 9.01436 14.7252 9.10019L10.6627 13.1627C10.4869 13.3383 10.2486 13.4369 10.0002 13.4369C9.75171 13.4369 9.51343 13.3383 9.33765 13.1627L5.27515 9.10019C5.09959 8.92441 5.00098 8.68613 5.00098 8.43769C5.00098 8.18925 5.09959 7.95097 5.27515 7.77519Z",
    fill: "#285FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.bae27cd2bdadce695d26b3887131f5ff.svg";
export { ForwardRef as ReactComponent };